import { useEffect, useState } from 'react';
import { Box, Typography, Container, Grid, Card, LinearProgress, Stack, Avatar
	, Table, TableRow, TableCell } from '@mui/material';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, LabelList } from 'recharts';
import Ribbon from '../tools/ribbon';
import CorporateKPIInput from './corporatekpiinput';
import CorporateKPIImport from './corporatekpiimport';
import LoadingPage from '../loadingPage';
import { useGetCorporateKPIMutation, useGetCorporatePermissionMutation } from '../../services/home';
import moment from 'moment';

let dateTargetRT = moment().startOf('month');
export default function CorporateKPI() {
	const [getCorporateKPI, corporateKPIResult] = useGetCorporateKPIMutation();
	const [getPermission, permissionResult] = useGetCorporatePermissionMutation();
	const [openInput, setOpenInput] = useState(false);
	const [data, setData] = useState({});
	const [record, setRecord] = useState({});
	const [permission, setPermission] = useState([]);
	const [dateTarget, setDateTarget] = useState(moment().startOf('month'));
	const warningColor = "#E53935";
	const warningColorBorder = "#ffa8a8";
	const successColor = "#2e7d32";
	const successColorBorder = "#a0d1a2ff";

	useEffect(() => {
		getData();
		getPermission();
		const intervalId = setInterval(() => {
			getData();
		}, 3600000); // 60000 milliseconds = 1 minute

		return () => clearInterval(intervalId);
	}, []);

	const getData=()=>{
		getCorporateKPI({type: 'getCorporateKPI', fromdate: moment(dateTargetRT).format('DD/MM/YYYY')});
	}

	useEffect(() => {
		if(permissionResult.data)
    {
			const dt = JSON.parse(permissionResult.data);
			setPermission(dt[0].dep.split(','));
		}
	}, [permissionResult]);

	useEffect(() => {
		if(corporateKPIResult.originalArgs && corporateKPIResult.originalArgs.type == "detailCorporateKPI"){
			if(corporateKPIResult.data){
				const dt = JSON.parse(corporateKPIResult.data);
				if(openInput == "Logistics"){
					let actual = 0;
					if(dt.length && dt.find(f=>f.field == 'actual'))
						actual=dt.find(f=>f.field == 'actual').value;
					setRecord({...record, actual: actual});
				}
			}
		}
		else if(corporateKPIResult.data)
    {
      const dt = JSON.parse(corporateKPIResult.data);
			let dataTotal = {sales: {}, d2c: {}, ecom: {}, b2b: {}, finance: {}, m_b: {}, dp: {}, training: {}, hr: {}
												, marketing: {}, procurement: {}, logistics: {}};

			const sales = dt.filter(f=>f.department == "Sales");
			sales && sales.map(m=>{
				dataTotal.sales[m.field] = m.value;
			});
			dataTotal.sales['sales_percent'] = dataTotal.sales?parseFloat(((dataTotal.sales.netsales||0)/(dataTotal.sales.target||1)*100).toFixed(1)):0;

			const d2c = dt.filter(f=>f.department == "D2C");
			d2c && d2c.map(m=>{
				dataTotal.d2c[m.field] = m.value;
				if(m.field.includes('upt') || m.field.includes('lfl'))
					m.name = moment(m.month).format('MMM YY');
			});
			dataTotal.d2c['upt_percent'] = dataTotal.d2c?parseFloat(((dataTotal.d2c.upt||0)/(dataTotal.d2c.upt_pre||1)*100).toFixed(1)):0;
			dataTotal.d2c['lfl_percent'] = dataTotal.d2c?parseFloat(((dataTotal.d2c.lfl||0)/(dataTotal.d2c.lfl_pre||1)*100).toFixed(1)):0;
			dataTotal.d2c['data_upt'] = d2c.filter(f=>f.name.includes("2") && f.field.includes('upt'));
			dataTotal.d2c['data_lfl'] = d2c.filter(f=>f.name.includes("2") && f.field.includes('lfl'));

			const ecom = dt.filter(f=>f.department == "ECOM");
			ecom && ecom.map(m=>{
				dataTotal.ecom[m.field] = m.value;
				if(m.field.includes('sales'))
					m.name = moment(m.month).format('MMM YY');
			});
			dataTotal.ecom['sales_percent'] = dataTotal.ecom?parseFloat(((dataTotal.ecom.sales||0)/(dataTotal.ecom.sales_pre||1)*100).toFixed(1)):0;
			dataTotal.ecom['data'] = ecom.filter(f=>f.name.includes("2"));

			const b2b = dt.filter(f=>f.department == "B2B");
			b2b && b2b.map(m=>{
				dataTotal.b2b[m.field] = m.value;
				if(m.field.includes('lfl'))
					m.name = moment(m.month).format('MMM YY');
			});
			dataTotal.b2b['lfl_percent'] = dataTotal.b2b?parseFloat(((dataTotal.b2b.lfl||0)/(dataTotal.b2b.lfl_pre||1)*100).toFixed(1)):0;
			dataTotal.b2b['discount_percent'] = dataTotal.b2b?parseFloat(((dataTotal.b2b.discount||0)/(dataTotal.b2b.discount_target||1)*100).toFixed(1)):0;
			dataTotal.b2b['data'] = b2b.filter(f=>f.name.includes("2"));
			dataTotal.b2b['data_discount'] = b2b.filter(f=>f.field.includes("discount"));

			const finance = dt.filter(f=>f.department == "Finance");
			finance && finance.map(m=>{
				dataTotal.finance[m.field] = m.value;
			});
			// dataTotal.finance['ebit_ytd'] = dataTotal.finance?parseFloat(((dataTotal.finance.actual_ytd||0)/(dataTotal.finance.budget_ytd||1)*100).toFixed(1)):0;
			// dataTotal.finance['ebit_fy'] = dataTotal.finance?
			// 	parseFloat((((dataTotal.finance.actual_ytd||0) + (dataTotal.finance.actual_ytg||0))
			// 		/(((dataTotal.finance.budget_ytd||0) + (dataTotal.finance.budget_ytg||0))||1)*100).toFixed(1)):0;
			dataTotal.finance['percent'] = dataTotal.finance?parseFloat(((dataTotal.finance.cost_actual||0)/(dataTotal.finance.last_month||1)*100).toFixed(1)):0;
			dataTotal.finance['data'] = [
				{name: 'Actual', value: dataTotal.finance?parseFloat(((dataTotal.finance.actual_ytd||0)/(dataTotal.finance.budget_ytd||1)*100).toFixed(1)):0},
				{name: 'LFC', value: dataTotal.finance?parseFloat(((dataTotal.finance.actual_ytg||0)/(dataTotal.finance.budget_ytg||1)*100).toFixed(1)):0}];
			dataTotal.finance['ebit_percent'] = dataTotal.finance?parseFloat(((dataTotal.finance['data'][0].value||0)/(dataTotal.finance['data'][1].value||1)*100).toFixed(1)):0;

			const m_b = dt.filter(f=>f.department == "M&B");
			m_b && m_b.map(m=>{
				dataTotal.m_b[m.field] = m.value;
			});
			dataTotal.m_b['percent'] = dataTotal.m_b?parseFloat(((dataTotal.m_b.sales||0)/(dataTotal.m_b.stock||1)*100).toFixed(1)):0;
			
			const dp = dt.filter(f=>f.department == "DP");
			dp && dp.map(m=>{
				dataTotal.dp[m.field] = m.value;
				m.name = (m.field=='target'?'Target':'Actual');
			});
			dataTotal.dp['percent'] = dataTotal.dp?parseFloat(((dataTotal.dp.actual||0)/(dataTotal.dp.target||1)*100).toFixed(1)):0;
			dataTotal.dp['data'] = dp;
			
			const training = dt.filter(f=>f.department == "Training");
			training && training.map(m=>{
				dataTotal.training[m.field] = m.value;
				m.name = (m.field=='target'?'Target':'Actual');
			});
			dataTotal.training['percent'] = dataTotal.training?parseFloat(((dataTotal.training.actual||0)/(dataTotal.training.target||1)*100).toFixed(1)):0;
			dataTotal.training['data'] = training;

			const hr = dt.filter(f=>f.department == "HR");
			hr && hr.map(m=>{
				dataTotal.hr[m.field] = m.value;
				if(m.field.includes('ave'))
					m.name = (m.field=='ave_target'?'Target':'Actual');
			});
			dataTotal.hr['ave_percent'] = dataTotal.hr?parseFloat(((dataTotal.hr.ave_actual||0)/(dataTotal.hr.ave_target||1)*100).toFixed(1)):0;
			dataTotal.hr['cost_percent'] = dataTotal.hr?parseFloat((((dataTotal.hr.d2c_actual||0)+(dataTotal.hr.b2b_actual||0)+(dataTotal.hr.ecom_actual||0))/
																(((dataTotal.hr.d2c_target||0)+(dataTotal.hr.b2b_target||0)+(dataTotal.hr.ecom_target||0))||1)*100).toFixed(1)):0;
			dataTotal.hr['data'] = hr.filter(f=>f.field.includes('ave'));

			const marketing = dt.filter(f=>f.department == "Marketing");
			marketing && marketing.map(m=>{
				dataTotal.marketing[m.field] = m.value;
				m.name = (m.field=='target'?'Target':'Actual');
			});
			dataTotal.marketing['percent'] = dataTotal.marketing?parseFloat(((dataTotal.marketing.actual||0)/(dataTotal.marketing.target||1)*100).toFixed(1)):0;
			dataTotal.marketing['data'] = marketing;

			const procurement = dt.filter(f=>f.department == "Procurement");
			procurement && procurement.map(m=>{
				dataTotal.procurement[m.field] = m.value;
				m.name = (m.field=='target'?'Target':'Actual');
			});
			dataTotal.procurement['percent'] = dataTotal.procurement?parseFloat(((dataTotal.procurement.actual||0)/(dataTotal.procurement.target||1)*100).toFixed(1)):0;
			dataTotal.procurement['data'] = procurement;

			const logistics = dt.filter(f=>f.department == "Logistics");
			logistics && logistics.map(m=>{
				if(moment(m.month).format("YYYYMM") == moment(dateTargetRT).format("YYYYMM"))
					dataTotal.logistics[m.field] = m.value;
				m.yyyymm = moment(m.month).format("MMM YYYY");
				m.label = `${moment(m.month).format("MMM: ")}${m.value}`;
			});
			dataTotal.logistics['data'] = logistics;
			// dataTotal.logistics['percent'] = dataTotal.logistics?((dataTotal.logistics.actual||0)/(dataTotal.logistics.target||1)*100).toFixed(1):0;
			
      setData(dataTotal);
    }
	}, [corporateKPIResult]);

	const onRecordClick = (department, item) =>{
		if(permission.includes(department)){
			setRecord({...item, department: department});
			setOpenInput(department);
		}
	}

	const handleChangeDateTarget=(value)=>{
		dateTargetRT = value;
		setDateTarget(dateTargetRT);
	}

	const onChangeDateTarget=()=>{
		// if(dataLoaded.TargetArgs && dataLoaded.TargetArgs.fromdate != moment(dateTargetRT).format('DD/MM/YYYY'))
			getData();
	}

	const LnChart=()=>{
		return <div style={{ width: '100%', height: 100 }}>
          <ResponsiveContainer>
            <LineChart
              data={data.logistics&&data.logistics.data?data.logistics.data:[]}
              margin={{ top: 5, right: 30, left: 30, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="yyyymm" hide={true} />
              {/* <YAxis /> */}
              <Tooltip />
              {/* <Legend /> */}
              {/* <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} /> */}
              <Line type="monotone" dataKey="value" stroke="#0092388b" strokeWidth={5}>
								<LabelList dataKey="label" position="bottom" fill='blue' style={{zIndex: 1000}}
									formatter={(value) => `${value}`} />
							</Line>
            </LineChart>
          </ResponsiveContainer>
        </div>
	}

	const BaChart=(DepName, text1, percent)=>{
		return <div style={{ width: '100%', height: (text1?100:120) }}>
						<Typography fontWeight={600} sx={{textAlign: 'center', marginTop: '5px'}}>{text1}{(percent&&DepName!='DP'&&DepName!='Training'&&DepName!='Marketing'&&DepName!='Procurement'&&DepName!='EBIT To NS')?`(${percent}%)`:''}</Typography>
						<ResponsiveContainer>
							<BarChart
								// style={{ width: '100%', maxWidth: '300px', maxHeight: '100px', aspectRatio: 1.618 }}
								responsive
								data={DepName=='D2C'&&data.d2c&&text1=='UPT'&&data.d2c.data_upt?data.d2c.data_upt
									:DepName=='D2C'&&data.d2c&&text1=='LFL'&&data.d2c.data_lfl?data.d2c.data_lfl
									:DepName=='ECOM'&&data.ecom&&text1=='LFL'&&data.ecom.data?data.ecom.data
									:DepName=='B2B'&&data.b2b&&text1=='LFL'&&data.b2b.data?data.b2b.data
									:DepName=='B2B'&&data.b2b&&text1=='Discount'&&data.b2b.data_discount?data.b2b.data_discount
									:DepName=='DP'&&data.dp&&data.dp.data?data.dp.data
									:DepName=='Training'&&data.training&&data.training.data?data.training.data
									:DepName=='Marketing'&&data.marketing&&data.marketing.data?data.marketing.data
									:DepName=='Procurement'&&data.procurement&&data.procurement.data?data.procurement.data
									:DepName=='HR'&&data.hr&&data.hr.data?data.hr.data
									:DepName=='EBIT To NS'&&data.finance&&data.finance.data?data.finance.data:[]}
							>
								<XAxis dataKey="name" stroke="blue" />
								{/* <YAxis width="auto" /> */}
								<Bar dataKey="value" fill={(text1=='Discount'||text1=='OOS'||text1=='Ave FTE/Store')?(percent>100?'red':'#52b202'):
																	(percent<100?'red':'#52b202')}>
									<LabelList dataKey="value" position="mid" fill='blue' 
									formatter={(value) => `${value}${text1=='LFL'?'tỷ':(text1=='Discount'||text1=='OOS'||DepName=='EBIT To NS')?'%':''}`} />
								</Bar>
							</BarChart>
						</ResponsiveContainer>
					</div>
	}

	const CardDep=(DepName, text1, value1, text2, value2)=>{
		const text1Width = text1=="Supplier Service Quality"?93:text1?text1.length*(text1.length>8?4.4:5):0;
		const text2Width = text2?text2.length*5:0;
    return <Card variant='outlined'
						sx={{
							pt: 5, borderRadius: 3, position: 'relative',
							boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
							width: '100%', minWidth: '125px', maxWidth: '350px', textAlign: 'center'
						}}
					>
						<Ribbon text={DepName} color={(((value1 <= 100 && (text1=='OOS'||text1=='Ave FTE/Store'||text1=='NPC & A&P Cost')) || (value1 >= 100 && text1!='OOS' && text1!='Ave FTE/Store' && text1!='NPC & A&P Cost')) 
																						&& ((value2 <= 100 && (text2=='Discount'||text2=='PC Cost')) || (value2 >= 100 && text2!='Discount' && text2!='PC Cost') || !text2))
							|| DepName=="Logistics" || (DepName=="M&B"&&value1>55) ? successColor : 
							((value1 > 100 && (text1=='OOS'||text1=='Ave FTE/Store'||text1=='NPC & A&P Cost'))||(value1 < 100 && text1!='OOS' && text1!='Ave FTE/Store' && text1!='NPC & A&P Cost')) && (((text2=='Discount'||text2=='PC Cost')&&(value2||0) > 100) || (value2||0) < 100) ? warningColor : 'orange'}/>
						<Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
							<Box sx={{position: 'relative', width: text2?'50%':'100%', height: '120px'}}>
								{DepName=="Logistics"?LnChart():(DepName=="D2C" || DepName=="ECOM" || DepName=="B2B" || DepName=="DP"
									 || DepName=="Training" || DepName=="Marketing" || DepName=="Procurement" || DepName=="HR" || DepName=="EBIT To NS"
								)?BaChart(DepName, text1, value1):
								<Gauge width={200} value={value1} startAngle={-100} endAngle={100} 
								innerRadius="66%" outerRadius="100%"
								text={({ value, valueMax }) => 
									`${Math.round((value/valueMax*100)*100)/100}%`
								}
								sx={{width: '100%', height: text1 && !text2 ? 110 : 120,
									[`& .${gaugeClasses.valueText}`]: {
										fontSize: 22, transform: 'translate(0px, -15px)'
									},
									[`& .${gaugeClasses.valueText} text`]: {
										fill: 'blue'
									},
									[`& .${gaugeClasses.valueArc}`]: {
										fill: ((text1=='NPC & A&P Cost')?(value1>100?'red':'#52b202'):(DepName=='M&B' && value1>=55)?'#52b202':value1<100?'red':'#52b202'),
									},
								}}/>}
								<Typography fontWeight={600} sx={{position: 'absolute', bottom: 0, left: `calc(50% - ${text1Width}px)`}}>
									{(DepName=="D2C" || DepName=="ECOM" || DepName=="B2B" || DepName=="DP"|| DepName=="Training" 
										|| DepName=="Marketing" || DepName=="Procurement" || DepName=="HR")?'':text1}</Typography>
							</Box>
							{text2?<Box sx={{position: 'relative', width: '50%', height: '120px'}}> 
								{(DepName=="D2C"||DepName=="B2B")?BaChart(DepName, text2, value2):
								<Gauge width={200} value={value2} startAngle={-100} endAngle={100} 
								innerRadius="66%" outerRadius="100%"
								text={({ value, valueMax }) => 
									`${Math.round((value/valueMax*100)*100)/100}%`
								}
								sx={{width: '100%', height: 120,
									[`& .${gaugeClasses.valueText}`]: {
										fontSize: 22, transform: 'translate(0px, -15px)'
									},
									[`& .${gaugeClasses.valueText} text`]: {
										fill: 'blue'
									},
									[`& .${gaugeClasses.valueArc}`]: {
										fill: (text2=='PC Cost')?(value2>100?'red':'#52b202'):(value2<100?'red':'#52b202'),
									},
								}}/>}
								<Typography fontWeight={600} sx={{position: 'absolute', bottom: 0, left: `calc(50% - ${text2Width}px)`}}>
									{(DepName=="D2C"||DepName=="B2B")?'':text2}</Typography>
							</Box>:''}
						</Box>
					</Card>
  }

	return (
		<div style={{padding: '20px 10px'}}>
			{ corporateKPIResult.isLoading && <LoadingPage /> }
			<Container maxWidth="sm" sx={{mb: { xs: 6, md: 0 },}}>
				<Grid container spacing={1}>
					<Box sx={{width: '100%'}}>
						<Typography variant="h7" fontWeight="700" color="blue" mt={0} mb={0} sx={{width: '190px', float: 'left'}} >
							EXECUTIVE VIEW
						</Typography>
						<Box sx={{float: 'right'
										, '& .MuiStack-root': {padding: '2px', overflow: 'hidden'}
										, '& .MuiPickersSectionList-root': {padding: 0}
										, '& .MuiPickersTextField-root': {minWidth: 0}
										, '& .MuiPickersInputBase-root': {fontSize: '16px', fontWeight: 'bold', width: '145px'}
										, '& .MuiButtonBase-root': {height: '30px'} }}>
							<LocalizationProvider dateAdapter={AdapterMoment}>
								<DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}>
									<DatePicker label={''} views={['month', 'year']} format="MMM YYYY" 
									value={dateTarget} onChange={handleChangeDateTarget} onClose={onChangeDateTarget} />
								</DemoContainer>
							</LocalizationProvider>
						</Box>
					</Box>
					<Grid size={{ xs: 6, md: 6 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							{CardDep("SALES", "", (data.sales?data.sales.sales_percent||0:0))}
						</Box>
					</Grid>
					<Grid size={{ xs: 6, md: 6 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							{CardDep("EBIT To NS", "", (data.finance?data.finance.ebit_percent||0:0))}
							{/* , "LFC", (data.finance?data.finance.ebit_fy||0:0))} */}
						</Box>
					</Grid>
				</Grid>
				<hr style={{border: 'none', borderTop: '1px dashed #ccc', height: '0'}}/>
{/*====================================================================================*/}
				<Grid container spacing={4} sx={{mt: 0}}>
					<Typography variant="h7" fontWeight="700" color="blue" mt={0} mb={-3} sx={{width: '100%'}} >
						FUNCTIONAL KPI VIEW
					</Typography>
{/*D2C---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("D2C", data.d2c||{})}>
								{CardDep("D2C", "UPT", (data.d2c?data.d2c.upt_percent||0:0), "LFL", (data.d2c?data.d2c.lfl_percent||0:0))}
						</Box>
					</Grid>
{/*ECOM---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("ECOM", {})}>
								{CardDep("ECOM", "LFL", (data.ecom?data.ecom.sales_percent||0:0))}
						</Box>
					</Grid>
{/*B2B---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("B2B", {})}>
								{CardDep("B2B", "LFL", (data.b2b?data.b2b.lfl_percent||0:0), "Discount", (data.b2b?data.b2b.discount_percent||0:0))}
						</Box>
					</Grid>
{/*Finance---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("Finance", data.finance||{})}>
								{CardDep("Finance", "NPC & A&P Cost", (data.finance?data.finance.percent||0:0))}
						</Box>
					</Grid>
{/*M&B---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("M&B", data.m_b||{})}>
							{CardDep("M&B", "Sell Thru", (data.m_b?data.m_b.percent||0:0))}
						</Box>
					</Grid>
{/*DP---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("DP", data.dp||{})}>
							{CardDep("DP", "OOS", (data.dp?data.dp.percent||0:0))}
						</Box>
					</Grid>
{/*Training---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("Training", data.training||{})}>
							{CardDep("Training", "NPS (staff service)", (data.training?data.training.percent||0:0))}
						</Box>
					</Grid>
{/*HR---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("HR", data.hr||{})}>
							{CardDep("HR", "Ave FTE/Store", (data.hr?data.hr.ave_percent||0:0), "PC Cost", (data.hr?data.hr.cost_percent||0:0))}
						</Box>
					</Grid>
{/*Marketing---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("Marketing", data.marketing||{})}>
							{CardDep("Marketing", "ROAS", (data.marketing?data.marketing.percent||0:0))}
						</Box>
					</Grid>
{/*Procurement---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("Procurement", data.procurement||{})}>
							{CardDep("Procurement", "Supplier Service Quality", (data.procurement?data.procurement.percent||0:0))}
						</Box>
					</Grid>
{/*Logistics---------------------------------------------------------------------------------*/}
					<Grid size={{ xs: 6, md: 3 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
							onClick={()=>onRecordClick("Logistics", data.logistics||{})}>
							{CardDep("Logistics", "TWSC/SU shipped", (data.logistics?data.logistics.percent||0:0))}
						</Box>
					</Grid>

				</Grid>
			</Container>

			<CorporateKPIInput open={openInput!="M&B" ? openInput : false} setOpen={setOpenInput} record={record} setRecord={setRecord}
				getData={getData} selectedDate={dateTarget} getCorporateKPI={getCorporateKPI} />
			<CorporateKPIImport open={openInput=="M&B" ? openInput : false} setOpen={setOpenInput} record={record} setRecord={setRecord}
				getData={getData} />
		</div>
	)
}